@if (notifications().length > 0) {
  <div class="notifications" role="status" aria-live="polite">
    @for (notification of notifications(); track notification.id) {
      <button
        type="button"
        class="notification"
        [class]="'notification--' + notification.variant"
        [class.notification--leaving]="notification.leaving"
        (click)="dismiss(notification.id)"
      >
        <span class="notification__text">
          <span class="notification__title">{{ notification.title }}</span>
          @if (notification.message) {
            <span class="notification__message">{{ notification.message }}</span>
          }
        </span>

        <span class="notification__badge" aria-hidden="true">
          @switch (notification.variant) {
            @case ('error') {
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 6 6 18M6 6l12 12"
                  stroke="currentColor"
                  stroke-width="2.4"
                  stroke-linecap="round"
                />
              </svg>
            }
            @case ('info') {
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 11v6M12 7.5h.01"
                  stroke="currentColor"
                  stroke-width="2.4"
                  stroke-linecap="round"
                />
              </svg>
            }
            @default {
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12.5 10 17.5 19 7.5"
                  stroke="currentColor"
                  stroke-width="2.4"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            }
          }
        </span>
      </button>
    }
  </div>
}
